import { DataCard } from '@/reports/index';
import { GoldenTag } from '@/reports/shared/DataCard/DataCardTag/DataCardTag';
import { Grid, Button, Text } from '@/theme/index';

interface RailCard {
  /** The title of the card. */
  title: string;
  /** The icon to display at the top of the card. */
  icon?: JSX.Element;
  /** The subtitle of the card. */
  subtitle?: string;
  /** The body of the card. */
  body: string;
  /** The text to display on the CTA. */
  buttonText?: string;
  /** The text to display on the tag if the tag is shown. */
  tagText?: string;
  /** Whether or not to show the tag. */
  showTag?: boolean;
  /** Whether or not to show the tag on the left side of the card. */
  tagOnLeft?: boolean;
  /** The function to call when the CTA is clicked. */
  onButtonClick?: () => void;
  /** The children of the card. */
  children?: React.ReactNode;
}

/**
 * This is a reuseable card component that can be used to display a basic CTA.
 */
export const RightRailCard = ({
  buttonText,
  icon,
  title,
  subtitle,
  body,
  tagText,
  showTag,
  tagOnLeft,
  onButtonClick,
  children,
}: RailCard) => {
  return (
    <DataCard
      cardStyles={{
        textAlign: 'center',
        padding: 1.5,
      }}
      boxStyles={{
        overflow: 'hidden',
      }}
      tag={
        showTag ? (
          <GoldenTag className={tagOnLeft ? 'align-left' : ''}>
            <Text fontWeight="bold">{tagText}</Text>
          </GoldenTag>
        ) : undefined
      }
      customBody={
        <Grid container direction="column" alignItems="center">
          <Grid item data-cy="right-rail-card-icon-grid">
            {icon}
          </Grid>
          <Grid item>
            <Text variant="h3" mb={1} data-cy="right-rail-card-title">
              {title}
            </Text>
          </Grid>
          {subtitle && (
            <Grid item>
              <Text variant="h6" sx={{ lineHeight: '20px' }}>
                {subtitle}
              </Text>
            </Grid>
          )}
          <Grid item mb={2}>
            <Text
              variant="caption"
              sx={{ lineHeight: '20px' }}
              data-cy="right-rail-card-body"
            >
              {body}
            </Text>
          </Grid>
          {buttonText && (
            <Grid item sx={{ width: '100%' }}>
              <Button
                variant="contained"
                sx={{ width: '100%' }}
                onClick={onButtonClick}
                color="success"
              >
                {buttonText}
              </Button>
            </Grid>
          )}
          {children}
        </Grid>
      }
    />
  );
};
